import { ComponentClassNames } from '../../util/classNames';
import { memoizeFunction, mergeStyleSets } from '../../util/styling';

type LayoutListItemClassNames = ComponentClassNames<'layoutListItem'>;

export const getClassNames = memoizeFunction(
  (fillWidth: boolean, className?: string): LayoutListItemClassNames =>
    mergeStyleSets({
      layoutListItem: [
        {
          flexGrow: fillWidth ? 1 : undefined,
        },
        'y-layoutList--item',
        className,
      ],
    })
);
